import React, { Fragment, useEffect, useState } from 'react';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import { STATUS } from 'chameleon-src/constants/assessmentStatus';
import { TEACHER_ORGANIZE_EXAMPLE_MODAL } from 'chameleon/legacy/src/components/TeacherOrganize/utils/constants';
import { buildUrl } from 'legacy-src/utility/buildUrl';
import { omit } from 'lodash';
import AssignedResources from './AssignedResources.svg';
import './styles.scss';

const AssignmentExampleModal = ({ assignmentExampleType, router }) => {
  const [showAssignmentExampleModal, setShowAssignmentExampleModal] =
    useState(true);
  useEffect(() => {
    setShowAssignmentExampleModal(true);
  }, [assignmentExampleType]);

  const toggleAssignmentExampleModal = () => {
    if (showAssignmentExampleModal) {
      const {
        params,
        routes,
        location: { query },
      } = router;
      const newQuery = omit(query, 'assignmentExampleModal');
      let newPathname;
      try {
        newPathname = buildUrl(routes, null, params, newQuery);
      } catch (e) {
        newPathname = `/${params.subject}/home`;
      }

      router.push(newPathname);
    }
    setShowAssignmentExampleModal(!showAssignmentExampleModal);
  };

  const getTitle = () => {
    switch (assignmentExampleType) {
      case STATUS.ALL_ASSIGNED:
        return 'Assigned Resources';
      case STATUS.ASSIGNED:
        return 'Active';
      case STATUS.READY_TO_SCORE:
        return 'Ready to Score';
      case STATUS.COMPLETED:
        return 'Completed';
      case TEACHER_ORGANIZE_EXAMPLE_MODAL.create:
        return TEACHER_ORGANIZE_EXAMPLE_MODAL.title;
      default:
        return '';
    }
  };

  const getContent = () => {
    switch (assignmentExampleType) {
      case STATUS.ALL_ASSIGNED:
        return (
          <span className="assignment_example_content">
            Teachers can view and manage all assigned assessments and videos,
            including locked Progress Checks. This is an example of what a
            teacher would see on this page.
            <br />
            <a
              href="https://apclassroom.clickhelp.co/articles/#!ap-classroom-user-guide-for-administrators-and-coordinators/adm-my-assignments"
              target="_blank"
            >
              Read more about Resources & Assignments - Assigned Resources in
              the Administrator and Coordinator’s Guide.
            </a>
            <img
              alt="Example teacher view of Assigned Resources page"
              className="mt-6"
              src={AssignedResources}
            />
          </span>
        );
      case STATUS.ASSIGNED:
        return (
          <span className="assignment_example_content">
            Teachers can view and manage only active assessment and video
            assignments, including locked Progress Checks. This is an example of
            what a teacher would see on this page.
            <br />
            <a
              href="https://apclassroom.clickhelp.co/articles/#!ap-classroom-user-guide-for-administrators-and-coordinators/adm-assignments-active"
              target="_blank"
            >
              Read more about Assignments – Active in the Administrator and
              Coordinator’s Guide.
            </a>
            <img className="mt-6" src={require('./active@2x.jpg')}></img>
          </span>
        );
      case STATUS.READY_TO_SCORE:
        return (
          <span className="assignment_example_content">
            Teachers can view and manage only assignments with FRQ responses
            that are ready to be scored. This is an example of what a teacher
            would see when they visit this page.
            <br />
            <a
              href="https://apclassroom.clickhelp.co/articles/#!ap-classroom-user-guide-for-administrators-and-coordinators/adm-assignments-ready-to-score"
              target="_blank"
            >
              Read more about Assignments – Ready to Score in the Administrator
              and Coordinator’s Guide.
            </a>
            <img
              className="mt-6"
              src={require('./ready-to-score@2x.jpg')}
            ></img>
          </span>
        );
      case STATUS.COMPLETED:
        return (
          <span className="assignment_example_content">
            Teachers can view and manage only completed assessment and video
            assignments. This is an example of what a teacher would see on this
            page.
            <br />
            <a
              href="https://apclassroom.clickhelp.co/articles/#!ap-classroom-user-guide-for-administrators-and-coordinators/adm-assignments-completed"
              target="_blank"
            >
              Read more about Assignments – Completed in the Administrator and
              Coordinator’s Guide.
            </a>
            <img className="mt-6" src={require('./completed@2x.jpg')}></img>
          </span>
        );
      case TEACHER_ORGANIZE_EXAMPLE_MODAL.create:
        return (
          <span className="assignment_example_content">
            Teachers can create labels and use them to group and quickly
            identify resources and assignments in ways that are most useful to
            them. They can choose to show this organization to their students.
            <br />
            <a
              href="https://apclassroom.clickhelp.co/articles/#!ap-classroom-user-guide-for-administrators-and-coordinators/adm-assignments-labels"
              target="_blank"
            >
              Read more about Labels in the Administrator and Coordinator’s
              Guide.
            </a>
            <img
              className="mt-6"
              src={require('./teacher-organize-labels@2x.jpg')}
            ></img>
          </span>
        );
      default:
        return '';
    }
  };

  const content = (
    <div className="mx-2 my-4">
      <span>{getContent()}</span>
    </div>
  );

  return (
    <Fragment>
      {showAssignmentExampleModal && (
        <ConfirmDialog
          size="huge"
          title={`Resources & Assignments - ${getTitle()}`}
          dialogClassName="AssignmentsExampleModal"
          wrapperClassName="AssignmentsExampleModal--content"
          onClose={toggleAssignmentExampleModal}
        >
          <Fragment>{content}</Fragment>
        </ConfirmDialog>
      )}
    </Fragment>
  );
};

export default AssignmentExampleModal;
